<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import TwBreadcrumbs from './TwBreadcrumbs';

export default {
  components: {
    TwBreadcrumbs,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    breadcrumbs: {
      type: Array,
      default: null,
    },
    bookingInfo: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    ...mapActions({
      loadBookingStayArea: 'booking/bookingStayAreaLoad',
    }),
    getAllStayAreas() {
      if (!this.bookingInfo.id && this.bookingInfo.stays.length === 0) {
        return '';
      }
      const bookingStayAreaIds = this.bookingInfo.stays.map(stay => stay.areaId);
      const areaIds = Object.values(this.areas).map(area => area.id);
      Object.values(bookingStayAreaIds).forEach((bookingStayAreaId) => {
        if (!areaIds.includes(bookingStayAreaId)) {
          this.loadBookingStayArea(bookingStayAreaId);
        }
      });
      const areaNames = this.areas.map(area => area.name);

      return areaNames.join(', ');
    },
  },
  computed: {
    ...mapGetters({
      twentyBookingUrl: 'booking/getTwentyBookingUrl',
    }),
    ...mapState({
      areas: state => state.booking.areas.items,
    }),
    titleHeading() {
      if (this.bookingInfo && this.bookingInfo.id !== undefined && this.bookingInfo.stays.length) {
        return this.title.replace(':areaName', this.getAllStayAreas());
      }
      return this.title;
    },
    allStaySupplierRefs() {
      if (!this.bookingInfo.id && this.bookingInfo.stays.length === 0) {
        return '';
      }
      const supplierRefs = this.bookingInfo.stays.map(stay => stay.bookingRefExternal);
      return supplierRefs.join(', ');
    },
  },
};
</script>

<template>
  <div class="tw-title-bar">
    <div class="d-flex flex-column">
      <div class="title">
        <v-list class="pa-3">
          {{ titleHeading }}
          <v-list-tile v-if="breadcrumbs">
            <tw-breadcrumbs :items="breadcrumbs" />
          </v-list-tile>
        </v-list>
      </div>
      <div
        v-if="bookingInfo !== undefined && bookingInfo.id !== undefined"
        class="mt-0 pa-2 text-xs-right"
      >
        {{ $t('breadcrumb-booking.booking-ref') }}:
        <a :href="twentyBookingUrl" target="_blank" class="font-weight-bold">
          {{ bookingInfo.bookingRef }}
        </a><br>
        {{ $t('breadcrumb-booking.supplier-refs') }}: <b>{{ allStaySupplierRefs }}</b><br>
        <template v-if="bookingInfo.customer.id">
          {{ $t('breadcrumb-booking.customer') }}:
          <b>{{ bookingInfo.customer.firstName + ' ' + bookingInfo.customer.lastName }}</b><br>
          {{ $t('breadcrumb-booking.phone') }}: <b>{{ bookingInfo.customer.phone }}</b>
        </template>
      </div>
    </div>
    <v-divider/>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/TwTitleBar.vue